export const HIGH = "high";
export const MEDIUM = "medium";
export const LOW = "low";

export default {
  HIGH,
  MEDIUM,
  LOW,
};
